import logo from "./logo.svg";
import dashboard from "./dashboard.svg";
import calendar from "./calendar.svg";
import clock from "./clock.svg";
import emptyStar from "./emptyStar.svg";
import filledStar from "./filled-star.svg";
import next from "./next.svg";
import smile from "./smile.svg";
import badge from "./badge.svg";
import trainer from "./trainer.svg";
import cPad from "./cPad.svg";
import duration from "./duration.svg";
import vtIcon from "./hlp_vlyoTutorials.svg";
import helpCenter from "./hlp_hlpCentre.svg";
import faqIcon from "./hlp_FAQ.svg";
import QnFeedbackIcon from "./hlp_queries_feedback.svg";
import FRequestIcon from "./hlp_featureRequest.svg";
import ContSupportIcon from "./hlp_contSupport.svg";
import yourCard from "./vCard_YourCard.svg";
import collectedCard from "./vCard_collectedCard.svg";
import language from "./settings_language.svg";
import changePWD from "./setting_changePWD.svg";
import vtt from "./vtt.svg";
import facebook from "./facebook.svg";
import google from "./google.svg";
import secondLogo from "./second-logo.svg";
import exclamation from "./exclamation.svg";
import successTick from "./successTick.svg";
import errorCross from "./errorCross.svg";
import cryEmoji from "./cry-emoji.svg";
import cryEmojiFilled from "./cry-emoji-filled.svg";
import upsetEmoji from "./upset-emoji.svg";
import upsetEmojiFilled from "./upset-emoji-filled.svg";
import neautralEmoji from "./netural-emoji.svg";
import neautralEmojiFilled from "./neutral-emoji-filled.svg";
import happyEmoji from "./happy-emoji.svg";
import happyEmojiFilled from "./happy-emoji-filled.svg";
import smileEmoji from "./smile-emoji.svg";
import smileEmojiFilled from "./smile-emoji-filled.svg";
import unfilledStar from "./unfilled-star.svg";
import unfilledBlueStar from "./unfilled-blue-star.svg";
import filledBlueStar from "./filled-blue-star.svg";
import filledHeart from "./filled-heart.svg";
import unfilledHeart from "./unfilled-heart.svg";
import unfilledThumsup from "./unfilled-thumbsup.svg";
import filledThumbsup from "./filled-thumsup.svg";
import unfilledEmoji from "./unfilled-emoji.svg";
import filledEmoji from "./filled-emoji.svg";

const Icon = {
  logo,
  dashboard,
  calendar,
  clock,
  successTick,
  errorCross,
  exclamation,
  filledStar,
  emptyStar,
  next,
  smile,
  badge,
  trainer,
  cPad,
  duration,
  vtIcon,
  helpCenter,
  faqIcon,
  QnFeedbackIcon,
  FRequestIcon,
  ContSupportIcon,
  yourCard,
  collectedCard,
  language,
  changePWD,
  vtt,
  facebook,
  google,
  secondLogo,
  cryEmoji,
  cryEmojiFilled,
  upsetEmoji,
  upsetEmojiFilled,
  neautralEmoji,
  neautralEmojiFilled,
  happyEmoji,
  happyEmojiFilled,
  smileEmoji,
  smileEmojiFilled,
  unfilledStar,
  unfilledBlueStar,
  filledBlueStar,
  filledHeart,
  unfilledHeart,
  filledThumbsup,
  unfilledThumsup,
  filledEmoji,
  unfilledEmoji,
};

export default Icon;
